import { useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import { useAppState } from "hooks/appState";
import { useApiService } from "hooks/apiService";
import { useLocalStorage } from "hooks/useLocalStorage";
import { Loader, Desktop, Mobile, Footer } from "components";
import styles from "./Home.module.scss";
import 'react-toastify/dist/ReactToastify.css';

export default function Home() {
  const [appState, setAppState] = useAppState();
  // eslint-disable-next-line no-unused-vars
  const { get } = useApiService();
  const [banners, setBanners] = useLocalStorage("banners", []);
  const [stands, setStands] = useLocalStorage("stands", []);

  const resizeHandler = () => {
    const isMobile = window.matchMedia("(max-width: 991px)").matches;
    if (isMobile) {
      setAppState({
        stand: null
      });
    }

    setAppState({ isMobile });
  };

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
    window.dispatchEvent(new Event("resize"));

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let isLoading = false;

    const fetchBanners = async () => {
      if (isLoading) {
        return;
      }
      isLoading = true;

      try {
        const { data: banners } = await get("banners");
        setBanners(banners.data);
        setAppState({ banners: banners.data });
        return Promise.resolve();
      } catch (error) {
        console.log(error);
      } finally {
        isLoading = false;
      }
    };

    if (banners.length) {
      setAppState({ banners });
    } else {
      fetchBanners();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let isLoading = false;

    const fetchStands = async () => {
      if (isLoading) {
        return;
      }
      isLoading = true;
      try {
        const { data: items } = await get("stands");

        setStands(items.data);
        return Promise.resolve();
      } catch (error) {
        console.log(error);
      } finally {
        isLoading = false;
      }
    };

    if (!stands.length) {
      fetchStands();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <main className={styles.c}>
        {appState.isMobile !== null && stands ? (
          <>{appState.isMobile ? <Mobile stands={stands} /> : <Desktop stands={stands} banners={banners} />}</>
        ) : (
          <div className={styles.l}>
            <Loader favicon={true} />
          </div>
        )}
      </main>
      <Footer></Footer>
      <ToastContainer position="bottom-right" closeOnClick theme="colored" autoClose="3000" />
    </>
  );
}
